import { modal, button } from "../../design/components.js";

export interface AppealSheetInput { action: string; statement: string; }
export interface AppealSheetCtx {
  t: (k: string, p?: Record<string, string | number>) => string;
  action: string;
  onSubmit: (input: AppealSheetInput) => Promise<void>;
  onClose: () => void;
}

/** Appeal bottom sheet (moderation spec §7). Self-sovereign, single statement. */
export function appealSheet(ctx: AppealSheetCtx): HTMLElement {
  const t = ctx.t;
  const body = document.createElement("div");
  body.className = "appeal-sheet__body";
  const sheet = modal({ title: t("appeal.title"), content: body, onClose: ctx.onClose, sheetId: "appeal" });

  let statement = "";

  function done(): HTMLElement {
    const wrap = document.createElement("div");
    wrap.setAttribute("data-step", "done");
    const p = document.createElement("p");
    p.className = "bx-body";
    p.textContent = t("appeal.done");
    const close = button({ label: t("appeal.submit"), variant: "primary", onClick: ctx.onClose });
    close.setAttribute("data-action", "done-close");
    wrap.append(p, close);
    return wrap;
  }

  function form(): HTMLElement {
    const wrap = document.createElement("div");
    wrap.setAttribute("data-step", "form");
    const intro = document.createElement("p");
    intro.className = "bx-microlabel";
    intro.textContent = t("appeal.intro");
    const input = document.createElement("input");
    input.type = "text";
    input.maxLength = 280;
    input.placeholder = t("appeal.statement.placeholder");
    input.setAttribute("data-statement", "");
    input.addEventListener("input", () => { statement = input.value; });
    const send = button({ label: t("appeal.submit"), variant: "primary", onClick: () => void submit() });
    send.setAttribute("data-action", "submit");
    wrap.append(intro, input, send);
    return wrap;
  }

  async function submit(): Promise<void> {
    try {
      await ctx.onSubmit({ action: ctx.action, statement });
      body.replaceChildren(done());
    } catch {
      const err = document.createElement("p");
      err.className = "bx-body appeal-sheet__error";
      err.textContent = t("appeal.error");
      body.append(err);
    }
  }

  body.replaceChildren(form());
  return sheet;
}
